import { AUTH } from "../constants";
import { getLocationHostname } from "./navigation";
const {
  REACT_APP_API_DOMAIN,
  REACT_APP_API_LOCAL_DOMAIN,
  REACT_APP_AUTH_API_DOMAIN,
  REACT_APP_AUTH_API_LOCAL_DOMAIN
} = process.env;
export const isDpdLocalDomain = () => getLocationHostname().includes(AUTH.DPD_LOCAL_DOMAIN);
export const getApisDomain = () => isDpdLocalDomain() ? REACT_APP_API_LOCAL_DOMAIN || REACT_APP_API_DOMAIN : REACT_APP_API_DOMAIN;
export const getAuthApisDomain = () => isDpdLocalDomain() ? REACT_APP_AUTH_API_LOCAL_DOMAIN || REACT_APP_AUTH_API_DOMAIN : REACT_APP_AUTH_API_DOMAIN;
export const isValidDPDorLocalHost = host => host && (host.endsWith(AUTH.DPD_DOMAIN) || host.endsWith(AUTH.DPD_LOCAL_DOMAIN));